The city or locality of the position location.

For example, "Melbourne" or "Sydney".
